import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** A real link only when the server verified a public account for this row. */
export function RosterProfileRow({
  profileId,
  className,
  children,
}: {
  profileId?: string | undefined;
  className: string;
  children: ReactNode;
}) {
  return profileId ? (
    <a
      href={`/players/${encodeURIComponent(profileId)}`}
      className={cn(
        className,
        "hover:bg-accent focus-visible:outline-2 focus-visible:outline-ring focus-visible:-outline-offset-2",
      )}
    >
      {children}
    </a>
  ) : (
    <div className={className}>{children}</div>
  );
}
